import type { paths } from '@orlikfy/api-interfaces';

export type {
  CreatedGamePlayerApplicationDto,
  GameDto,
  GamePlayerDto,
  PlayerGameDto,
  PlayerGameInvitationDto,
  CommonLocationDto,
  HostDto,
  GamePlayerApplicationDto,
  GameDetailsHostDto,
  CancelPlayerGameDto
} from '@orlikfy/api-interfaces';

// GET /games/{gameId}
export const GET_GAME_BY_ID_PATH = '/games/{gameId}' as const satisfies keyof paths;
type GetGameByIdOperation = paths[typeof GET_GAME_BY_ID_PATH]['get'];
export type GetGameByIdPathParams = GetGameByIdOperation['parameters']['path'];
export type GetGameByIdResponse = GetGameByIdOperation['responses'][200]['content']['application/json'];

// POST /games/{gameId}/player-applications
export const SEND_PLAYER_APPLICATION_PATH = '/games/{gameId}/player-applications' as const satisfies keyof paths;
type SendPlayerApplicationOperation = paths[typeof SEND_PLAYER_APPLICATION_PATH]['post'];
export type SendPlayerApplicationPathParams = SendPlayerApplicationOperation['parameters']['path'];
export type SendPlayerApplicationResponse =
  SendPlayerApplicationOperation['responses'][200]['content']['application/json'];

// DELETE /games/{gameId}/player-applications
export const DELETE_PLAYER_APPLICATION_PATH = '/games/{gameId}/player-applications' as const satisfies keyof paths;
type DeletePlayerApplicationOperation = paths[typeof DELETE_PLAYER_APPLICATION_PATH]['delete'];
export type DeletePlayerApplicationPathParams = DeletePlayerApplicationOperation['parameters']['path'];

// DELETE /player-games/{gameId}
export const CANCEL_PLAYER_GAME_PATH = '/player-games/{gameId}' as const satisfies keyof paths;
type CancelPlayerGameOperation = paths[typeof CANCEL_PLAYER_GAME_PATH]['delete'];
export type CancelPlayerGamePathParams = CancelPlayerGameOperation['parameters']['path'];
